export const getReturnLabelsFormatted = returnLabels => {
  return returnLabels?.map(label => ({
    url: label?.qr_label_url || label?.label_url,
    type: label?.qr_label_url ? 'qr' : 'label',
  }))
}
